import { connectorApi } from 'api/connector/api'
import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { appSelectors } from 'redux/reducers/app'
import { notifyError } from 'shared/errors'
import { useAppSelector } from 'shared/hooks'
import { Param } from 'shared/search-adapters'

import { api } from '../api'
import { useIsEnable } from './useIsEnable'

const hardReload = () => window.location.reload()

const enum Case {
	Skip,
	InPending,
	NotFound,
	Ready
}

export function useParamPerson() {
	const [params, setParams] = useSearchParams()
	const personId = params.get(Param.PersonId) ?? ''

	const currentId = useAppSelector(
		state => appSelectors.persona(state)?.personaId ?? ''
	)

	const isCurrent = currentId === personId
	useLogoutToMain(Boolean(personId && !isCurrent))
	const allowTeam = useAllowTeam()
	// ! Temp solution
	const skipCheck = !allowTeam || !personId || isCurrent

	const query = api.usePersonasQuery(undefined, {
		skip: skipCheck
	})

	const shouldFind = !skipCheck && query.isSuccess
	const result = useMemo(() => {
		if (!shouldFind) {
			return Case.Skip
		}

		const found = query.data.documents.find(
			member => member.persona_id === personId
		)

		if (found === undefined) {
			return Case.NotFound
		}
		if (found.pending) {
			return Case.InPending
		}

		return Case.Ready
	}, [shouldFind, query.data, personId])

	const [changePerson] = connectorApi.useSignInUnderTeamMemberMutation()

	useEffect(() => {
		switch (result) {
			case Case.InPending:
			case Case.NotFound: {
				setParams(prev => {
					prev.set(Param.PersonId, '')
					return prev
				})
				return
			}
			case Case.Ready: {
				changePerson(personId)
				return
			}
		}
	}, [result, changePerson, setParams, personId])

	return skipCheck
}

function useAllowTeam() {
	const hasTeam = useIsEnable()
	const isImpersonated = useAppSelector(appSelectors.isImpersonated)
	return !isImpersonated && hasTeam
}

function useLogoutToMain(shouldDrop = false) {
	const isImpersonated = useAppSelector(appSelectors.isImpersonated)

	const [signOut] = connectorApi.useStopMemberSessionMutation()

	useEffect(() => {
		if (shouldDrop && isImpersonated) {
			signOut().unwrap().then(hardReload).catch(notifyError)
		}
	}, [shouldDrop, isImpersonated, signOut])
}
